import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const Pmdg737MarketingSeo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="Fly with confidence">
        <Text fz="medium">
          The PMDG 737's in-depth systems modelling offers direct control of the aircraft's
          hydraulic, electric, pressurization, and other systems -- just like in the real 737. With
          so many systems to manage it can be easy to forget one of them, especially if you aren't
          flying the plane every day. <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Checklist.............Customized">
        <Text fz="medium">
          Start with our 737 checklist and customize it to your liking using the web-based editor.
          Add more checklist items to remember to start your other addons, color-code important
          memory items, and download your checklist as a PDF. Checklists can be exported and shared
          with a friend or first officer, and are saved in your browser, so you can come back and
          change them later.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
